import Cookies from 'js-cookie'
import { getSearchParams } from 'gatsby-query-params'

const generateAppLink = (path, locale, params) => {
  const partneroPartnerId = getSearchParams('aff').aff || Cookies.get('partnero_partner')

  if (partneroPartnerId) {
    return params
      ? `${process.env.APP_BASE_URL}${path}?${params}&lang=${locale}&aff=${partneroPartnerId}`
      : `${process.env.APP_BASE_URL}${path}?lang=${locale}&aff=${partneroPartnerId}`
  }

  return params
    ? `${process.env.APP_BASE_URL}${path}?${params}&lang=${locale}`
    : `${process.env.APP_BASE_URL}${path}?lang=${locale}`
}

const areAllFieldsNotEmpty = (fields, obj) => {
  return fields.every((field) => obj[field] && obj[field].trim() !== '')
}

const getLanguageNameByLocale = (locale) => {
  const names = {
    en: 'English',
    es: 'Spanish',
    pt: 'Portuguese',
    fr: 'French',
    de: 'German',
    it: 'Italian',
    pl: 'Polish',
    nl: 'Dutch',
    sr: 'Serbian',
  }

  return names[locale]
}

export { generateAppLink, areAllFieldsNotEmpty, getLanguageNameByLocale }
